import React from 'react'
import SummaryRow from '../../SummaryRow'
import { formatGasCost, weiToEther } from '../../../utils/walletUtils'

const GasSummary = ({ isShielding, gasEstimate, loading, error }) => {
  // Show loading state
  if (loading) {
    return (
      <div
        className="card mb-3"
      >
        <div className='card-body p-3'>
          <h6 className="fw-semibold mb-3 ">Gas Fees</h6>
          <div className="text-center py-3">
            <div className="spinner-border spinner-border-sm text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="small mt-2 mb-0" style={{ color: 'var(--text-secondary)' }}>Estimating gas fees...</p>
          </div>
        </div>
      </div>
    )
  }

  // Show error state
  if (error) {
    return (
      <div
        className="card mb-3"
      >
        <div className='card-body p-3'>
          <h6 className="fw-semibold mb-2 ">Gas Fees</h6>
          <p className="text-warning small mb-0">⚠️ Unable to estimate gas fees. Using default estimates.</p>
        </div>
      </div>
    )
  }

  // Show real gas estimate if available
  if (gasEstimate) {
    const network = gasEstimate.tokenDetails?.network || 'polygon'
    const totalCost = formatGasCost(gasEstimate.totalCost, network)
    const gasPrice = weiToEther(gasEstimate.gasPrice, 9) // Gas price is in Gwei (9 decimals)

    return (
      <div
        className="card mb-3"
      >
        <div className='card-body p-3'>
          <h6 className="fw-semibold mb-3 ">Gas Fees</h6>

          <SummaryRow label="Gas Estimate" value={`${gasEstimate.gasEstimate} units`} />
          <SummaryRow label="Gas Price" value={`${parseFloat(gasPrice).toFixed(2)} Gwei`} />

          <div className="d-flex justify-content-between align-items-center fw-semibold pt-4">
            <span>Total Gas Cost:</span>
            <span className="text-primary">~{totalCost}</span>
          </div>

          <p className="mt-2 mb-0 opacity-80 font-semibold">
            ⓘ Gas fees are estimates and may vary based on network conditions
          </p>
        </div>
      </div>
    )
  }

  // Fallback to default estimates
  return (
    <div
      className="card mb-3"
    >
      <div className='card-body p-4'>
        <h6 className="fw-semibold mb-3 ">Gas Fees</h6>

        <SummaryRow label={`${isShielding ? 'Shield' : 'Unshield'} Fee`} value={isShielding ? '~$2.80' : '~$3.20'} />
        <SummaryRow label="Network Fee" value="~$2.50" />

        <div className="d-flex justify-content-between align-items-center fw-semibold pt-4">
          <span>Total Gas Cost:</span>
          <span className="text-primary">{isShielding ? '~$5.30' : '~$5.70'}</span>
        </div>
      </div>
    </div>
  )
}

export default GasSummary
